import { useEffect } from 'react';

export function fmtDate(s) {
  if (!s) return '—';
  const d = String(s).slice(0, 10);
  if (d.length < 10) return String(s);
  return `${d.slice(8, 10)}-${d.slice(5, 7)}-${d.slice(0, 4)}`;
}

export function localDateStr(d) {
  return [d.getFullYear(), String(d.getMonth()+1).padStart(2,'0'), String(d.getDate()).padStart(2,'0')].join('-');
}

export function weekMonday(offset = 0) {
  const d = new Date();
  d.setDate(d.getDate() - d.getDay() + 1 + offset * 7);
  return localDateStr(d);
}

export function monthRange(offset = 0) {
  const d = new Date();
  d.setMonth(d.getMonth() + offset, 1);
  const from = localDateStr(d);
  const last = new Date(d.getFullYear(), d.getMonth() + 1, 0);
  const to = localDateStr(last);
  return { from, to, label: d.toLocaleString('en-GB', { month: 'long', year: 'numeric' }) };
}

/* ── Shared UI helpers ─────────────────────────────────────────────────────
   Keep interaction and identity colour consistent across every page. */

/* Spread onto a non-<button> element to make it keyboard-operable:
   Tab reaches it, Enter / Space activate it, and it announces as a button.
   Use a real <button> when the element is genuinely a button and layout allows;
   use this for rows, cards, and tiles that must stay <div>s. */
export const clickable = (fn) => ({
  role: 'button',
  tabIndex: 0,
  onClick: fn,
  onKeyDown: (e) => {
    if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); fn(); }
  },
});

/* Stable per-person identity colour, keyed by the person's name rather than a
   list index, so someone keeps the same colour across every widget regardless
   of roster order or the team-only filter. DESIGN.md: identity colour is data. */
export const TEAM_PALETTE = ['#2563eb', '#1a80a0', '#7c3aed', '#1a8f4e', '#bf7c1a', '#c42028', '#0f766e', '#9333ea'];
export function personColor(name) {
  if (!name) return 'var(--text-2)';
  let h = 0;
  for (let i = 0; i < name.length; i++) h = (h * 31 + name.charCodeAt(i)) | 0;
  return TEAM_PALETTE[Math.abs(h) % TEAM_PALETTE.length];
}

/* Move focus into a drawer/dialog on open and restore it to the trigger on
   close. Pair with role="dialog" aria-modal="true" tabIndex={-1} on the panel. */
export function useDrawerFocus(ref) {
  useEffect(() => {
    const prev = document.activeElement;
    ref.current?.focus();
    return () => { try { prev?.focus?.(); } catch { /* trigger unmounted */ } };
  }, [ref]);
}
